var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 10.25L8 11.75L7.25 10.25V6.3935C5.95925 6.05825 5 4.8935 5 3.5C5 1.8455 6.3455 0.5 8 0.5C9.6545 0.5 11 1.8455 11 3.5C11 4.8935 10.0407 6.05825 8.75 6.3935V10.25ZM10.8005 8.36825L11.2003 6.92225C13.8523 7.655 15.5 9.21725 15.5 11C15.5 13.523 12.2052 15.5 8 15.5C3.79475 15.5 0.5 13.523 0.5 11C0.5 9.21725 2.14775 7.655 4.8005 6.9215L5.20025 8.3675C3.25625 8.90525 2 9.938 2 11C2 12.419 4.46375 14 8 14C11.5363 14 14 12.419 14 11C14 9.938 12.7438 8.90525 10.8005 8.36825Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon--pin.bb1a8f6d8db5f3f4d46aebbf99bfb9bf.svg";
export { ForwardRef as ReactComponent };